export default {
  methods: {
    formatNumber(value) {
      return numeral(value).format('0,0');
    }
  }
}
